module.exports = __webpack_public_path__ + "prod/1.42.2/img/yycj_one.f44bc874.png";